import { createFileRoute } from '@tanstack/react-router'
import { FacebookPostTool } from '~/features/crossposting/components/facebook-post-tool'

export const Route = createFileRoute('/dashboard/crossposting/$listingId/facebook')({
  component: FacebookRoute,
})

function FacebookRoute() {
  const { listingId } = Route.useParams()
  return <FacebookPostTool listingId={listingId} />
}
